import { FC } from "react";
import { Typography } from "@mui/material";
import { TitleWidgetProps } from "./TitleWidget.types";

export const TitleWidget: FC<TitleWidgetProps> = ({ config }) => {
  const size = config?.font?.size ? config.font.size : `14px`;
  return <Typography sx={{ fontSize: `${size}` }}>{config.value}</Typography>;
};
